var map = {
	"./Home": [
		96807,
		6807
	],
	"./Home.vue": [
		96807,
		6807
	],
	"./HomeTable": [
		95367,
		5367
	],
	"./HomeTable.vue": [
		95367,
		5367
	],
	"./admin/PlatformSettings": [
		60216,
		5262,
		209,
		216
	],
	"./admin/PlatformSettings.vue": [
		60216,
		5262,
		209,
		216
	],
	"./admin/Users": [
		96185,
		6185
	],
	"./admin/Users.vue": [
		96185,
		6185
	],
	"./admin/operations/BulkComponentUpdate": [
		78561,
		8561
	],
	"./admin/operations/BulkComponentUpdate.vue": [
		78561,
		8561
	],
	"./admin/operations/BulkPriceDataUpdate": [
		22595,
		2595
	],
	"./admin/operations/BulkPriceDataUpdate.vue": [
		22595,
		2595
	],
	"./admin/operations/Export": [
		10725,
		725
	],
	"./admin/operations/Export.vue": [
		10725,
		725
	],
	"./admin/operations/GenerateFactsheets": [
		79212,
		5262,
		9212
	],
	"./admin/operations/GenerateFactsheets.vue": [
		79212,
		5262,
		9212
	],
	"./admin/operations/OverrideHoldingData": [
		34910,
		7645,
		4910
	],
	"./admin/operations/OverrideHoldingData.vue": [
		34910,
		7645,
		4910
	],
	"./admin/products/AccessRestrictions": [
		876,
		5262,
		209,
		876
	],
	"./admin/products/AccessRestrictions.vue": [
		876,
		5262,
		209,
		876
	],
	"./admin/products/Followers": [
		26850,
		7645,
		6850,
		7068
	],
	"./admin/products/Followers.vue": [
		26850,
		7645,
		6850,
		7068
	],
	"./admin/products/General": [
		41067,
		5262,
		209,
		8039,
		6877,
		7844
	],
	"./admin/products/General.vue": [
		41067,
		5262,
		209,
		8039,
		6877,
		7844
	],
	"./admin/products/HoldingData": [
		68199,
		7645,
		4203,
		8199,
		4635
	],
	"./admin/products/HoldingData.vue": [
		68199,
		7645,
		4203,
		8199,
		4635
	],
	"./admin/products/PriceData": [
		42386,
		7645,
		2386,
		4687
	],
	"./admin/products/PriceData.vue": [
		42386,
		7645,
		2386,
		4687
	],
	"./admin/products/Products": [
		29987,
		5262,
		209,
		8039,
		6877,
		7645,
		4203,
		6850,
		2386,
		8199,
		3681
	],
	"./admin/products/Products.vue": [
		29987,
		5262,
		209,
		8039,
		6877,
		7645,
		4203,
		6850,
		2386,
		8199,
		3681
	],
	"./admin/settings/Compliance": [
		41068,
		1068
	],
	"./admin/settings/Compliance.vue": [
		41068,
		1068
	],
	"./admin/settings/Roles": [
		48604,
		5262,
		209,
		8604
	],
	"./admin/settings/Roles.vue": [
		48604,
		5262,
		209,
		8604
	],
	"./auth/login/Login": [
		13485,
		3485
	],
	"./auth/login/Login.vue": [
		13485,
		3485
	],
	"./auth/login/Login2fa": [
		70128,
		128
	],
	"./auth/login/Login2fa.vue": [
		70128,
		128
	],
	"./auth/login/LoginFirebase": [
		84736,
		4736
	],
	"./auth/login/LoginFirebase.vue": [
		84736,
		4736
	],
	"./auth/register/Register": [
		70101,
		7650,
		9353
	],
	"./auth/register/Register.vue": [
		70101,
		7650,
		9353
	],
	"./auth/register/Register2fa": [
		9683,
		9683
	],
	"./auth/register/Register2fa.vue": [
		9683,
		9683
	],
	"./auth/register/RegisterFirebase": [
		57650,
		7650,
		1821
	],
	"./auth/register/RegisterFirebase.vue": [
		57650,
		7650,
		1821
	],
	"./auth/resetPassword/ResetPasswordForm": [
		73135,
		3135
	],
	"./auth/resetPassword/ResetPasswordForm.vue": [
		73135,
		3135
	],
	"./compliance/InvestorProfile": [
		91812,
		1812
	],
	"./compliance/InvestorProfile.vue": [
		91812,
		1812
	],
	"./compliance/Ombudsman": [
		79325,
		9325
	],
	"./compliance/Ombudsman.vue": [
		79325,
		9325
	],
	"./compliance/PrivacyPolicy": [
		40833,
		833
	],
	"./compliance/PrivacyPolicy.vue": [
		40833,
		833
	],
	"./compliance/TermsOfUse": [
		10548,
		548
	],
	"./compliance/TermsOfUse.vue": [
		10548,
		548
	],
	"./compliance/custom/bcf/PrivacyPolicy": [
		65489,
		5489
	],
	"./compliance/custom/bcf/PrivacyPolicy.vue": [
		65489,
		5489
	],
	"./customSections/demo/useCases/Alpinum": [
		58740,
		5051,
		9340,
		8975
	],
	"./customSections/demo/useCases/Alpinum.vue": [
		58740,
		5051,
		9340,
		8975
	],
	"./errors/Error403": [
		38454,
		8454
	],
	"./errors/Error403.vue": [
		38454,
		8454
	],
	"./errors/Error404": [
		62042,
		2042
	],
	"./errors/Error404.vue": [
		62042,
		2042
	],
	"./errors/UnauthorizedInvestorProfile": [
		30996,
		996
	],
	"./errors/UnauthorizedInvestorProfile.vue": [
		30996,
		996
	],
	"./help/Contact": [
		11397,
		1397
	],
	"./help/Contact.vue": [
		11397,
		1397
	],
	"./help/Faq": [
		62615,
		2615
	],
	"./help/Faq.vue": [
		62615,
		2615
	],
	"./help/KnowledgeBase": [
		14048,
		4048
	],
	"./help/KnowledgeBase.vue": [
		14048,
		4048
	],
	"./help/knowledgeBaseTerm/KnowledgeBaseTerm": [
		45725,
		5725
	],
	"./help/knowledgeBaseTerm/KnowledgeBaseTerm.vue": [
		45725,
		5725
	],
	"./help/knowledgeBaseTerm/components/Alpha": [
		74489,
		4489
	],
	"./help/knowledgeBaseTerm/components/Alpha.vue": [
		74489,
		4489
	],
	"./help/knowledgeBaseTerm/components/AnnualizedReturn": [
		87690,
		7690
	],
	"./help/knowledgeBaseTerm/components/AnnualizedReturn.vue": [
		87690,
		7690
	],
	"./help/knowledgeBaseTerm/components/AnnualizedVola": [
		60775,
		775
	],
	"./help/knowledgeBaseTerm/components/AnnualizedVola.vue": [
		60775,
		775
	],
	"./help/knowledgeBaseTerm/components/Beta": [
		88783,
		8783
	],
	"./help/knowledgeBaseTerm/components/Beta.vue": [
		88783,
		8783
	],
	"./help/knowledgeBaseTerm/components/CalmarRatio": [
		60554,
		554
	],
	"./help/knowledgeBaseTerm/components/CalmarRatio.vue": [
		60554,
		554
	],
	"./help/knowledgeBaseTerm/components/Correlation": [
		81605,
		1605
	],
	"./help/knowledgeBaseTerm/components/Correlation.vue": [
		81605,
		1605
	],
	"./help/knowledgeBaseTerm/components/CumulativeReturn": [
		14965,
		4965
	],
	"./help/knowledgeBaseTerm/components/CumulativeReturn.vue": [
		14965,
		4965
	],
	"./help/knowledgeBaseTerm/components/InformationRatio": [
		61582,
		1582
	],
	"./help/knowledgeBaseTerm/components/InformationRatio.vue": [
		61582,
		1582
	],
	"./help/knowledgeBaseTerm/components/Kurtosis": [
		17138,
		4757
	],
	"./help/knowledgeBaseTerm/components/Kurtosis.vue": [
		17138,
		4757
	],
	"./help/knowledgeBaseTerm/components/M2RiskAdjustedPerf": [
		25872,
		5872
	],
	"./help/knowledgeBaseTerm/components/M2RiskAdjustedPerf.vue": [
		25872,
		5872
	],
	"./help/knowledgeBaseTerm/components/MaxDrawdown": [
		49186,
		9186
	],
	"./help/knowledgeBaseTerm/components/MaxDrawdown.vue": [
		49186,
		9186
	],
	"./help/knowledgeBaseTerm/components/OmegaRatio": [
		24607,
		4607
	],
	"./help/knowledgeBaseTerm/components/OmegaRatio.vue": [
		24607,
		4607
	],
	"./help/knowledgeBaseTerm/components/ReturnToVolaRatio": [
		95154,
		5154
	],
	"./help/knowledgeBaseTerm/components/ReturnToVolaRatio.vue": [
		95154,
		5154
	],
	"./help/knowledgeBaseTerm/components/SharpeRatio": [
		74154,
		4154
	],
	"./help/knowledgeBaseTerm/components/SharpeRatio.vue": [
		74154,
		4154
	],
	"./help/knowledgeBaseTerm/components/Skewness": [
		81834,
		1834
	],
	"./help/knowledgeBaseTerm/components/Skewness.vue": [
		81834,
		1834
	],
	"./help/knowledgeBaseTerm/components/SortinoRatio": [
		90424,
		424
	],
	"./help/knowledgeBaseTerm/components/SortinoRatio.vue": [
		90424,
		424
	],
	"./help/knowledgeBaseTerm/components/TrackingError": [
		17652,
		7652
	],
	"./help/knowledgeBaseTerm/components/TrackingError.vue": [
		17652,
		7652
	],
	"./help/knowledgeBaseTerm/components/TreynorRatio": [
		2417,
		2417
	],
	"./help/knowledgeBaseTerm/components/TreynorRatio.vue": [
		2417,
		2417
	],
	"./help/knowledgeBaseTerm/components/ValueAtRisk": [
		57074,
		7074
	],
	"./help/knowledgeBaseTerm/components/ValueAtRisk.vue": [
		57074,
		7074
	],
	"./help/knowledgeBaseTerm/sectionsAndTerms": [
		89633,
		9633
	],
	"./help/knowledgeBaseTerm/sectionsAndTerms.js": [
		89633,
		9633
	],
	"./products/DefaultAnalysis": [
		3651,
		5051,
		5262,
		209,
		8039,
		6877,
		9340,
		1104,
		1473,
		7301
	],
	"./products/DefaultAnalysis.vue": [
		3651,
		5051,
		5262,
		209,
		8039,
		6877,
		9340,
		1104,
		1473,
		7301
	],
	"./products/DefaultDocumentDownload": [
		64196,
		4196
	],
	"./products/DefaultDocumentDownload.vue": [
		64196,
		4196
	],
	"./products/DefaultDocuments": [
		44754,
		8039,
		4754
	],
	"./products/DefaultDocuments.vue": [
		44754,
		8039,
		4754
	],
	"./products/DefaultEmbeddedPerfGraph": [
		41153,
		5051,
		1413
	],
	"./products/DefaultEmbeddedPerfGraph.vue": [
		41153,
		5051,
		1413
	],
	"./products/DefaultEmbeddedPerfTable": [
		32542,
		2542
	],
	"./products/DefaultEmbeddedPerfTable.vue": [
		32542,
		2542
	],
	"./products/DefaultEmbeddedStatsTable": [
		10063,
		63
	],
	"./products/DefaultEmbeddedStatsTable.vue": [
		10063,
		63
	],
	"./products/DefaultFactsheet": [
		32979,
		5051,
		5262,
		209,
		8039,
		6877,
		1104,
		7318,
		2473,
		6967,
		9274
	],
	"./products/DefaultFactsheet.vue": [
		32979,
		5051,
		5262,
		209,
		8039,
		6877,
		1104,
		7318,
		2473,
		6967,
		9274
	],
	"./products/DefaultFactsheetForPdfGeneration": [
		36845,
		5051,
		5262,
		209,
		8039,
		6877,
		1104,
		7318,
		2473,
		6967,
		9892
	],
	"./products/DefaultFactsheetForPdfGeneration.vue": [
		36845,
		5051,
		5262,
		209,
		8039,
		6877,
		1104,
		7318,
		2473,
		6967,
		9892
	],
	"./products/DefaultLastFactsheetDownload": [
		53391,
		3391
	],
	"./products/DefaultLastFactsheetDownload.vue": [
		53391,
		3391
	],
	"./products/DefaultOverview": [
		94056,
		5051,
		5262,
		209,
		8039,
		6877,
		1104,
		7318,
		4203,
		2473,
		2313
	],
	"./products/DefaultOverview.vue": [
		94056,
		5051,
		5262,
		209,
		8039,
		6877,
		1104,
		7318,
		4203,
		2473,
		2313
	],
	"./products/alquant/alcrypto/Analysis": [
		8661,
		5051,
		5262,
		209,
		8039,
		6877,
		9340,
		1104,
		1473,
		7318,
		3095
	],
	"./products/alquant/alcrypto/Analysis.vue": [
		8661,
		5051,
		5262,
		209,
		8039,
		6877,
		9340,
		1104,
		1473,
		7318,
		3095
	],
	"./products/alquant/alvola/InternalAnalysis": [
		37192,
		5051,
		5262,
		209,
		8039,
		6877,
		9340,
		1104,
		1473,
		7318,
		5008
	],
	"./products/alquant/alvola/InternalAnalysis.vue": [
		37192,
		5051,
		5262,
		209,
		8039,
		6877,
		9340,
		1104,
		1473,
		7318,
		5008
	],
	"./products/alquant/alvola/UseCase": [
		44839,
		5051,
		9340,
		6750
	],
	"./products/alquant/alvola/UseCase.vue": [
		44839,
		5051,
		9340,
		6750
	],
	"./products/alquant/alvolaWithFutures/Analysis": [
		67047,
		5051,
		5262,
		209,
		8039,
		6877,
		9340,
		1104,
		1473,
		7769
	],
	"./products/alquant/alvolaWithFutures/Analysis.vue": [
		67047,
		5051,
		5262,
		209,
		8039,
		6877,
		9340,
		1104,
		1473,
		7769
	],
	"./products/alquant/alvolaWithFutures/UseCase": [
		98971,
		5051,
		9340,
		6026
	],
	"./products/alquant/alvolaWithFutures/UseCase.vue": [
		98971,
		5051,
		9340,
		6026
	],
	"./products/alquant/lifeSciencesToolsAndServices/LiveAnalysis": [
		14030,
		5051,
		5262,
		209,
		8039,
		6877,
		9340,
		1104,
		1473,
		4166
	],
	"./products/alquant/lifeSciencesToolsAndServices/LiveAnalysis.vue": [
		14030,
		5051,
		5262,
		209,
		8039,
		6877,
		9340,
		1104,
		1473,
		4166
	],
	"./products/alquant/proTech/InternalAnalysis": [
		56101,
		5051,
		5262,
		209,
		8039,
		6877,
		9340,
		1104,
		1473,
		7318,
		1479
	],
	"./products/alquant/proTech/InternalAnalysis.vue": [
		56101,
		5051,
		5262,
		209,
		8039,
		6877,
		9340,
		1104,
		1473,
		7318,
		1479
	],
	"./products/alquant/quantCore/Analysis": [
		19883,
		5051,
		5262,
		209,
		8039,
		6877,
		9340,
		1104,
		1473,
		7318,
		6637
	],
	"./products/alquant/quantCore/Analysis.vue": [
		19883,
		5051,
		5262,
		209,
		8039,
		6877,
		9340,
		1104,
		1473,
		7318,
		6637
	],
	"./products/alquant/ynnovation/InternalAnalysis": [
		33979,
		5051,
		5262,
		209,
		8039,
		6877,
		9340,
		1104,
		1473,
		7318,
		4365
	],
	"./products/alquant/ynnovation/InternalAnalysis.vue": [
		33979,
		5051,
		5262,
		209,
		8039,
		6877,
		9340,
		1104,
		1473,
		7318,
		4365
	],
	"./products/falgom/taroDiversified/UseCase": [
		70198,
		5051,
		9340,
		8969
	],
	"./products/falgom/taroDiversified/UseCase.vue": [
		70198,
		5051,
		9340,
		8969
	],
	"./products/msm/slgOpportunitiesFund/UseCase": [
		96054,
		5051,
		9340,
		3225
	],
	"./products/msm/slgOpportunitiesFund/UseCase.vue": [
		96054,
		5051,
		9340,
		3225
	],
	"./settings/ChangePassword": [
		42530,
		2530
	],
	"./settings/ChangePassword.vue": [
		42530,
		2530
	],
	"./settings/DeleteAccount": [
		44798,
		4798
	],
	"./settings/DeleteAccount.vue": [
		44798,
		4798
	],
	"./settings/EditProfile": [
		90520,
		520
	],
	"./settings/EditProfile.vue": [
		90520,
		520
	],
	"./settings/Overview": [
		26719,
		6719
	],
	"./settings/Overview.vue": [
		26719,
		6719
	],
	"./settings/Settings": [
		61094,
		1094
	],
	"./settings/Settings.vue": [
		61094,
		1094
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 99555;
module.exports = webpackAsyncContext;